import { render, staticRenderFns } from "./courses.view.vue?vue&type=template&id=25435b48&scoped=true"
import script from "./courses.view.vue?vue&type=script&lang=js"
export * from "./courses.view.vue?vue&type=script&lang=js"
import style0 from "./courses.view.vue?vue&type=style&index=0&id=25435b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25435b48",
  null
  
)

export default component.exports